import type {Iso8601DateTime, Uuid} from "@vesta/common-type-definitions/typeDefinitions";

export enum WidgetType {
    areaGraph = "aeecf29e-69fc-40e7-abec-f9f647292dbb",
    comboChart = "f9dc7327-d8ff-4921-9c7f-d0211d195f14",
    donutChart = "3665af28-14c2-4744-b588-2f6dcccc21ee",
    gauge = "a6a355a3-09bb-4cc7-8eae-a79c27560e8a",
    horizontalBarGraph = "b81ec749-5615-4a00-8df3-8ea34834fd50",
    image = "2f4d5eef-78dc-40f0-b0aa-02e98e8f3015",
    lineGraph = "63b8f630-0350-4f69-92ed-a15050d4eca5",
    multiBarGraph = "ad0b9684-8460-4dac-9695-52250538ac72",
    numberTile = "82cf1203-ef30-44e0-a35b-84dd3af93103",
    pieChart = "0598c8d6-930a-435f-a3c1-8e25f1e65370",
    progressBar = "ba6413fa-aa63-436b-957d-581b2a46024b",
    stackedBarGraph = "e125b8f6-bf87-49b7-ba36-dbf797cc70b7",
    table = "a0fd3e45-0ed5-4308-9dfa-6e8e32d93437",
    text = "d5d60556-fc8c-4582-a8ac-f489e22a894e",
}

export enum CanvasControlType {
    dateRange = "0c96bb93-4ea7-4252-b63e-8763ff6334b9",
    granularity = "569a4ad2-f909-4146-8537-7bcbb64128c7",
    multiSelect = "88a37b8b-2525-494e-8913-b95377a21fb2",
    select = "e955068f-00e7-4862-a1ee-6848b8477f2b",
}

export enum DateRangeOptions {
    lastFourteenDays = "c80cd0cb-df06-40a6-b891-db1ff29f71ba",
    lastMonth = "f2355cfd-610a-4a3b-ae43-0ae6b9c5a537",
    lastMonthToDate = "f1113080-f8c2-46db-aaec-fd33f4d4ca3e",
    lastQuarter = "14152cf9-09f9-4b38-b0d0-1df6de3c826d",
    lastQuarterToDate = "af5bfb01-c1a9-46c8-9f86-11a717ac3d63",
    lastSevenDays = "ea2c02a0-3dfe-4fb9-940b-c91cacc00c63",
    lastThirtyDays = "188731e9-fb42-4b9b-a03b-f9fd7ee9ab66",
    lastWeek = "68cfa38e-0ce0-4a5e-84e1-94943cf7bcd6",
    lastYear = "58412a34-4543-479d-b278-43d31acdf10e",
    lastYearToDate = "2265a1c5-fd48-4674-8475-ecff282de975",
    monthToDate = "c7f19cee-b41b-4697-a8e2-38c64fe32475",
    yesterday = "fc927bbc-ddbf-4d01-bf22-f24146941645",
    thisWeek = "e3d40518-6ad9-47c1-98d5-e3c832807ea0",
    today = "c302b22c-5097-442a-8ab6-917ca1eae4fa",
    yearToDate = "8597452d-207e-4983-b0a6-8b6e379e29e2",
    quarterToDate = "2d444c55-07ef-4162-97b8-6a2201f9be03",
}

export enum FilterOperations {
    equals = "9bf4a803-3c97-4ede-8226-2f286e4bad33",
}

export enum WidgetValueType {
    canvasControl = "6e2b2115-6b76-47d6-8540-181bdea6a2b4",
    intrinsic = "77adefb5-2f53-4151-a1df-11de211acb93",
}

export enum Granularity {
    day = "day",
    month = "month",
    year = "year",
}

export enum BackendFilterValueTypes {
    dataDriven = "d58a6ec2-e55c-4551-bb73-223e9b6f0a87",
    globalFilter = "63bba872-0783-47c0-8df9-366f3e78e962",
}

export enum BackendFilterTypes {
    and = "21049b0c-569f-4a37-9dc5-5fac882fff08",
    atomic = "4b02c64c-de3c-43ae-a6be-b84baea167cb",
}

export enum BackendFilterOperations {
    between = "1b40b607-8da0-48b0-9ab0-7fe53cab4a1d",
    contains = "0e55fe86-1062-4fe2-95be-92b9ae0c71ea",
    equals = "bafb6b6c-90ca-42bc-9ee9-2ac60ff6c3e7",
    greaterThan = "cdadd5e6-68f6-48e2-b56f-fc41ee91d2bb",
    greaterThanEqualTo = "15f683d5-f335-4ff6-8d4f-5cbe55e675bb",
    in = "4e61f5af-3ed9-4ae9-befd-d8fdcb73ebad",
    lessThan = "f5aec8bc-42c4-4062-b82e-cd567d2e0091",
    lessThanEqualTo = "f990d2dd-a7e5-46b7-887a-1c907c565e05",
}

export enum EratoDataTypes {
    boolean = "boolean",
    date = "date",
    numeric = "numeric",
    string = "string",
    text = "text",
    timestamp = "timestamp",
}

export enum NumberSystems {
    indian = "ad039db5-d6ef-458b-94dd-bf1af21f9615",
    international = "cfdded75-863e-464e-89dc-786d03add599",
    none = "5dc156aa-da04-4ca5-af5a-e7eeeed84e3f",
}

export enum ComposedChartType {
    area = "97198e06-89af-4401-9692-1e1bd257e69b",
    bar = "1419f381-226d-4835-87b0-71bdfd332629",
    line = "26b75ed2-8258-471d-a736-ba737e9fcb71",
}

export enum TableColumnDataTypes {
    numeric = "0253f346-f6aa-4afa-85ba-a14811a5b0f3",
    string = "f01fb873-f89f-476b-b1df-ab1e4bbd21d2",
}

export enum TableColumnTextOverflow {
    truncate = "58b588bd-1bab-4601-9841-b06e6effcccd",
    wrap = "d61faa0d-2fdd-48d8-bef9-8016cad647f9",
}

export enum ColumnSortType {
    ascending = "a6993884-dd24-4924-8bd6-4eb3e27371ab",
    descending = "6c22f5c4-4eb3-4d13-9d7b-0f5d88c63d6a",
}

export type WidgetSorts = {
    [sortColumnKey: string]: ColumnSortType | null;
};

export type WidgetBase = {
    col: number;
    colSpan: number;
    id: Uuid;
    row: number;
    rowSpan: number;
};

export type WidgetDateConfig = {
    dateRange: DateRangeOptions | null;
    dateRangeCanvasControl: Uuid | null;
    endDateIso: Iso8601DateTime | null;
    startDateIso: Iso8601DateTime | null;
};

export type WidgetSelectionLimits = {
    maxDimensionSelections: number;
    maxMetricSelections: number;
    minDimensionSelections: number;
    minMetricSelections: number;
};

export type WidgetMetricOnlySelectionLimits = {
    maxMetricSelections: number;
    minMetricSelections: number;
};

export type WidgetFrontendFilters = Record<
    string,
    {
        attributeId: Uuid;
        [FilterOperations.equals]: Array<string>;
    }
>;

export type WidgetAttributeMetadata = {
    displayName: string;
    id: Uuid;
    type: EratoDataTypes;
};

export type WidgetMetrics = Record<Uuid, WidgetAttributeMetadata>;

export type WidgetDimensions = Record<Uuid, WidgetAttributeMetadata>;

export type AtomicFilter = {
    attribute: Uuid | null;
    filterType: BackendFilterTypes.atomic;
    id: Uuid;
} & (
    | {
          globalFilterId: Uuid;
          valueType: BackendFilterValueTypes.globalFilter;
      }
    | {
          valueType: BackendFilterValueTypes.dataDriven;
      }
) &
    (| {
          operation: BackendFilterOperations.equals | BackendFilterOperations.contains | null;
          tempValue: string | number | null;
          value: string | number | null;
      }
    | {
          operation: BackendFilterOperations.in | null;
          tempValue: string | null;
          value: Array<string> | null;
      }
    | {
          operation:
              | BackendFilterOperations.greaterThan
              | BackendFilterOperations.greaterThanEqualTo
              | BackendFilterOperations.lessThan
              | BackendFilterOperations.lessThanEqualTo
              | null;
          tempValue: number | null;
          value: number | null;
      }
    | {
          operation: BackendFilterOperations.between;
          tempValue: [number | null, number | null];
          value: [number | null, number | null];
      });

export type BackendFilter = {
    filterType: BackendFilterTypes.and;
    filters: Array<AtomicFilter>;
    id: Uuid;
};

export type GranularityForWidget =
    | {
          type: WidgetValueType.intrinsic;
          value: Granularity;
      }
    | {
          type: WidgetValueType.canvasControl;
          value: Uuid;
      };

export type ChartSeriesDetails = {
    selectedMetric: Uuid;
    yAxisId: "left" | "right";
};

export type ComboChartSeriesDetails = {
    selectedMetrics: Array<Uuid>;
    type: ComposedChartType | null;
    yAxisId: "left" | "right";
};

export type SharedChartWidgetConfig = WidgetBase & WidgetDateConfig & WidgetSelectionLimits & {
    areCanvasControlsLinked: boolean;
    backendFilter: BackendFilter | null;
    chartSeriesDetails: Array<ChartSeriesDetails>;
    datasetId: Uuid | null;
    dimensions: WidgetDimensions | null;
    filters: WidgetFrontendFilters;
    granularity: GranularityForWidget;
    isTitleEdited: boolean;
    metrics: WidgetMetrics | null;
    selectedDimensions: Array<Uuid>;
    selectedMetrics: Array<Uuid>;
    title: string | null;
};

export type MultiBarGraphWidget = SharedChartWidgetConfig & {
    type: WidgetType.multiBarGraph;
};

export type StackedBarGraphWidget = SharedChartWidgetConfig & {
    selectedSlicer: Uuid | null;
    type: WidgetType.stackedBarGraph;
};

export type HorizontalBarGraphWidget = SharedChartWidgetConfig & {
    type: WidgetType.horizontalBarGraph;
};

export type LineGraphWidget = SharedChartWidgetConfig & {
    type: WidgetType.lineGraph;
};

export type AreaGraphWidget = SharedChartWidgetConfig & {
    type: WidgetType.areaGraph;
};

export type ComboChartWidget = Omit<SharedChartWidgetConfig, "chartSeriesDetails"> & {
    chartSeriesDetails: Array<ComboChartSeriesDetails>;
    type: WidgetType.comboChart;
};

export type PieOrDonutChartWidgetConfig = WidgetBase & WidgetDateConfig & WidgetSelectionLimits & {
    areCanvasControlsLinked: boolean;
    backendFilter: BackendFilter | null;
    datasetId: Uuid | null;
    dimensions: WidgetDimensions | null;
    filters: WidgetFrontendFilters;
    isTitleEdited: boolean;
    metrics: WidgetMetrics | null;
    selectedDimensions: Array<Uuid>;
    selectedMetrics: Array<Uuid>;
    title: string | null;
    valuesPrefix: string | null;
};

export type PieChartWidget = PieOrDonutChartWidgetConfig & {
    type: WidgetType.pieChart;
};

export type DonutChartWidget = PieOrDonutChartWidgetConfig & {
    type: WidgetType.donutChart;
};

export type ColumnProperties = {
    columnDataType: TableColumnDataTypes;
    columnTextOverflow: TableColumnTextOverflow;
    columnTitle: string;
    columnWidth: number;
    isColumnWidthEdited: boolean;
};

export type TableComparisonConfig = {
    enabled: boolean;
    startDateIso: Iso8601DateTime | null;
    endDateIso: Iso8601DateTime | null;
};

export type TableWidget = WidgetBase & WidgetDateConfig & {
    areCanvasControlsLinked: boolean;
    backendFilter: BackendFilter | null;
    columnProperties: Record<string, ColumnProperties>;
    comparison?: TableComparisonConfig;
    columnsToSort?: WidgetSorts | null;
    datasetId: Uuid | null;
    dimensions: WidgetDimensions | null;
    filters: WidgetFrontendFilters;
    granularity: GranularityForWidget;
    isTitleEdited: boolean;
    maxDimensionSelections: null;
    maxMetricSelections: null;
    metrics: WidgetMetrics | null;
    minDimensionSelections: number;
    minMetricSelections: number;
    selectedDimensions: Array<Uuid>;
    selectedMetrics: Array<Uuid>;
    transposeDimensionId?: Uuid | null;
    title: string | null;
    type: WidgetType.table;
};

export type NumberTileWidget = WidgetBase & WidgetDateConfig & WidgetMetricOnlySelectionLimits & {
    areCanvasControlsLinked: boolean;
    backendFilter: BackendFilter | null;
    datasetId: Uuid | null;
    decimalPlaces: number;
    filters: WidgetFrontendFilters;
    fontSizeMultiplier: number;
    isTitleEdited: boolean;
    metrics: WidgetMetrics | null;
    numberSystem: NumberSystems;
    selectedMetrics: Array<Uuid>;
    spreadValue?: boolean;
    title: string | null;
    type: WidgetType.numberTile;
    valuePrefix: string | null;
    valueSuffix: string | null;
};

export type ProgressBarWidget = WidgetBase & WidgetDateConfig & WidgetMetricOnlySelectionLimits & {
    backendFilter: BackendFilter | null;
    datasetId: Uuid | null;
    metrics: WidgetMetrics | null;
    selectedMetrics: Array<Uuid>;
    targetValue: number | null;
    title: string | null;
    type: WidgetType.progressBar;
};

export type GaugeWidget = Omit<ProgressBarWidget, "type"> & {
    type: WidgetType.gauge;
};

export type TextWidget = WidgetBase & {
    bold: boolean;
    fontSizeMultiplier: number;
    italic: boolean;
    strikethrough: boolean;
    text: string;
    textHorizontalAlign: "left" | "center" | "right";
    textVerticalAlign: "top" | "center" | "bottom";
    type: WidgetType.text;
    underline: boolean;
};

export type ImageWidget = WidgetBase & {
    image: string | null;
    type: WidgetType.image;
};

export type StoredWidget =
    | MultiBarGraphWidget
    | StackedBarGraphWidget
    | HorizontalBarGraphWidget
    | LineGraphWidget
    | AreaGraphWidget
    | ComboChartWidget
    | TableWidget
    | NumberTileWidget
    | PieChartWidget
    | DonutChartWidget
    | TextWidget
    | ProgressBarWidget
    | GaugeWidget
    | ImageWidget;

export type ReportPage = {
    id: Uuid;
    title: string;
    widgets: Array<StoredWidget>;
};

export type DabbaToAttributeMapping = Record<
    Uuid,
    {
        dimensions: Array<Uuid>;
        metrics: Array<Uuid>;
    }
>;

export type CanvasControlBase = {
    dabbaToAttributeMapping: DabbaToAttributeMapping;
    id: Uuid;
    isActive: boolean;
    name: string;
};

export type CanvasControlGranularity = CanvasControlBase & {
    defaultValue: string;
    type: CanvasControlType.granularity;
    value: string;
    values: Array<string>;
};

export type CanvasControlDateRange = CanvasControlBase & {
    dateRange: DateRangeOptions | null;
    defaultDateRange: DateRangeOptions | null;
    defaultValue: [Iso8601DateTime | null, Iso8601DateTime | null];
    type: CanvasControlType.dateRange;
    value: [Iso8601DateTime | null, Iso8601DateTime | null];
};

export type CanvasControlSelect = CanvasControlBase & {
    defaultValue: string;
    type: CanvasControlType.select;
    value: string;
};

export type CanvasControlMultiSelect = CanvasControlBase & {
    defaultValue: Array<string>;
    type: CanvasControlType.multiSelect;
    value: Array<string>;
};

export type CanvasControl =
    | CanvasControlGranularity
    | CanvasControlDateRange
    | CanvasControlSelect
    | CanvasControlMultiSelect;

export type CanvasControls = Record<Uuid, CanvasControl>;
